module.exports = __webpack_public_path__ + "20250828d091945t/img/pic_wangluoweilianjie@2x.a82041ec.png";